<div class="model-selector-container">
  <ion-select
    class="model-selector-label"
    label=""
    label-placement="stacked"
    [placeholder]="placeholder | translate"
    [value]="selectedClientId"
    (ionChange)="handleChange($event)"
    interface="popover"
    [interfaceOptions]="{ header: headerText | translate }"
    [disabled]="!hasClients">
    <ion-select-option *ngFor="let client of clients" [value]="client.id">
      {{client.name}}
    </ion-select-option>
  </ion-select>
  <div *ngIf="!hasClients" class="no-clients-message">
    <ion-text color="medium">
      <small>{{ 'COMMON.NO_CLIENTS_AVAILABLE' | translate }}</small>
    </ion-text>
  </div>
</div>
